import styled from 'styled-components';

export const HeadingIconWrapper = styled.div`
    && {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-left: -6px;
        > span {
            margin-left: 6px;
        }
    }
`;
